(function () {
  var COLORS = ['#c4724a', '#fbe4e7', '#f5d0d4', '#141414', '#ffffff'];
  var busy = false;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function showToast() {
    if (document.querySelector('.uc-ship-celebration')) return;

    var el = document.createElement('div');
    el.className = 'uc-ship-celebration';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<div class="uc-ship-celebration__card">' +
      '<p class="uc-ship-celebration__eyebrow">Free shipping</p>' +
      '<p class="uc-ship-celebration__title">You unlocked free shipping!</p>' +
      '<p class="uc-ship-celebration__sub">On this order — $100+</p>' +
      '</div>';

    document.body.appendChild(el);
    requestAnimationFrame(function () {
      el.classList.add('is-visible');
    });

    window.setTimeout(function () {
      el.classList.remove('is-visible');
      window.setTimeout(function () {
        el.remove();
      }, 450);
    }, 2800);
  }

  function confetti() {
    if (prefersReducedMotion()) return;

    var canvas = document.createElement('canvas');
    canvas.className = 'uc-ship-celebration__canvas';
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    if (!ctx) {
      canvas.remove();
      return;
    }

    var particles = [];
    var count = Math.min(72, Math.max(36, Math.floor(window.innerWidth / 10)));

    for (var i = 0; i < count; i++) {
      particles.push({
        x: canvas.width * 0.5 + (Math.random() - 0.5) * canvas.width * 0.35,
        y: canvas.height * 0.38 + (Math.random() - 0.5) * 80,
        w: 4 + Math.random() * 5,
        h: 5 + Math.random() * 7,
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        vx: (Math.random() - 0.5) * 5,
        vy: -2 - Math.random() * 3,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.18,
        opacity: 1,
      });
    }

    var start = performance.now();
    var duration = 2200;

    function frame(now) {
      var t = now - start;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach(function (p) {
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.11;
        p.vx *= 0.995;
        p.rot += p.vr;
        if (t > duration * 0.65) {
          p.opacity = Math.max(0, 1 - (t - duration * 0.65) / (duration * 0.35));
        }
        ctx.save();
        ctx.globalAlpha = p.opacity;
        ctx.fillStyle = p.color;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });

      if (t < duration) requestAnimationFrame(frame);
      else canvas.remove();
    }

    requestAnimationFrame(frame);
  }

  window.__ucShipCelebrate = function () {
    if (busy) return;
    busy = true;
    showToast();
    confetti();
    window.setTimeout(function () {
      busy = false;
    }, 3000);
  };
})();
